import request from '@/utils/request'
import { v2Host } from '@/config/host'

const cookUrl = (name) => `${v2Host}/dashboard/report/${name}`

export function queryReport(params) {
  return request({
    url: v2Host + '/dashboard/report/query',
    method: 'post',
    data: params
  })
}

export function getPlayableReport(params) {
  return request({
    url: cookUrl('query'),
    method: 'post',
    data: params
  })
}
